/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CommunityIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Community',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10.05859,11.99805c-2.08887,0-3.78809-1.78418-3.78809-3.97754s1.69922-3.97852,3.78809-3.97852,3.78809,1.78516,3.78809,3.97852-1.69922,3.97754-3.78809,3.97754Zm0-6.45605c-1.26172,0-2.28809,1.1123-2.28809,2.47852s1.02637,2.47754,2.28809,2.47754,2.28809-1.11133,2.28809-2.47754-1.02637-2.47852-2.28809-2.47852Z"
      fill="currentColor"
    />
    <path
      d="m4.55322,17.99805c-.02686,0-.0542-.00098-.08154-.00391-.41211-.04492-.70947-.41504-.66504-.82715.27588-2.5459,2.96338-4.4668,6.25195-4.4668,3.26465,0,6.01123,1.96582,6.25293,4.47559.03955.41309-.26221.7793-.6748.81836-.41504.04297-.77832-.2627-.81836-.67383-.16553-1.7207-2.30078-3.12012-4.75977-3.12012-2.47949,0-4.5708,1.37402-4.76074,3.12891-.0415.38379-.3667.66895-.74463.66895Z"
      fill="currentColor"
    />
    <path
      d="m.74951,14.99805c-.13672,0-.27539-.03711-.39941-.11523-.35059-.2207-.45557-.68457-.23438-1.03516.85596-1.35742,2.43994-2.31152,4.34521-2.61426.4126-.07129.79346.21289.85889.62207.06494.40918-.21387.79395-.62256.8584-1.45752.23242-2.6958.95508-3.31299,1.93457-.14258.22559-.38623.34961-.63477.34961Z"
      fill="currentColor"
    />
    <path
      d="m4.18652,9.99805c-.05273,0-.10596-.00586-.15967-.01758-1.74756-.37891-3.01611-2.01758-3.01611-3.89453,0-2.19336,1.69922-3.97754,3.7876-3.97754.68457,0,1.35547.19336,1.93994.55957.35107.21973.45752.68262.23779,1.03418-.2207.35059-.68408.45508-1.03369.2373-.3457-.2168-.74121-.33105-1.14404-.33105-1.26123,0-2.2876,1.11133-2.2876,2.47754,0,1.17676.77148,2.19824,1.83447,2.42969.40479.08789.66162.4873.57373.8916-.07617.35156-.38721.59082-.73242.59082Z"
      fill="currentColor"
    />
    <path
      d="m19.25049,14.99805c-.24902,0-.49219-.12402-.63477-.34961-.61719-.97949-1.85547-1.70215-3.31299-1.93457-.40869-.06445-.6875-.44922-.62256-.8584.06543-.40918.44922-.69238.85889-.62207,1.90527.30273,3.48926,1.25684,4.34521,2.61426.22119.35059.11621.81445-.23438,1.03516-.12402.07812-.2627.11523-.39941.11523Z"
      fill="currentColor"
    />
    <path
      d="m15.81348,9.99805c-.3457,0-.65625-.23926-.73242-.59082-.08789-.4043.16895-.80371.57373-.8916,1.06299-.23145,1.83447-1.25293,1.83447-2.42969,0-1.36621-1.02637-2.47754-2.2876-2.47754-.40283,0-.79834.11426-1.14404.33105-.34912.21777-.81348.11328-1.03369-.2373-.21973-.35156-.11328-.81445.23779-1.03418.58447-.36621,1.25537-.55957,1.93994-.55957,2.08838,0,3.7876,1.78418,3.7876,3.97754,0,1.87695-1.26855,3.51562-3.01611,3.89453-.05371.01172-.10693.01758-.15967.01758Z"
      fill="currentColor"
    />
  </svg>`;
};
